var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWand({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.853 11.264l-2.47-2.46 1.589-3.103a.5.5 0 00-.673-.673l-3.103 1.589-2.46-2.47a.5.5 0 00-.849.432l.552 3.442L9.33 9.598a.5.5 0 00.15.94l2.832.443-8.166 8.165a.5.5 0 10.708.707l8.165-8.165.443 2.833a.5.5 0 00.94.149l1.577-3.11 3.442.553a.5.5 0 00.432-.848zm-4.076-.749a.5.5 0 00-.525.268l-1.041 2.053-.356-2.274a.5.5 0 00-.417-.417l-2.274-.356 2.053-1.04a.5.5 0 00.268-.526L13.12 5.95l1.625 1.631a.5.5 0 00.582.092l2.049-1.049-1.05 2.05a.5.5 0 00.093.581l1.63 1.625-2.272-.365zm.255 5.35a.5.5 0 01-.283.647l-.005.002a.5.5 0 11-.365-.93l.005-.003a.5.5 0 01.648.283zm2.764-.425a.5.5 0 01-.285.647l-.006.002a.5.5 0 11-.361-.933l.005-.002a.5.5 0 01.647.286zM7.486 8.254l.003-.006a.5.5 0 11.929.37l-.002.005a.5.5 0 11-.93-.37zm.426-2.762l.003-.006a.5.5 0 11.93.368l-.003.005a.5.5 0 01-.93-.367z"
  })));
}

export default SvgWand;